import * as types from "./action-types";
import { errorHandler } from "../../../utils/errors";
import DriverAllocationApi from "../../../api/DriverAllocationApi";

//Get the driver allocations - table data
export const fetchDriverAllocations = params => ({
    type: types.FETCH_DRIVER_ALLOCATIONS,
    payload: DriverAllocationApi.fetchDriverAllocations(params)
});


//Fetch Driver Allocation details
export const fetchDriverAllocationDetails = params => ({
    type: types.FETCH_DRIVER_ALLOCATION_DETAILS,
    payload: DriverAllocationApi.getDriverAllocationDetails(params)
});


/** Fetch Driver details **/
export const fetchDriverDetails = (params, driverId) => ({
    type: types.FETCH_DRIVER_DETAILS,
    payload: DriverAllocationApi.getDriverDetails(params, driverId)
});



// WEBPACK FOOTER //
// ./src/features/relocations/driver/actions.js